import React from 'react';
import { BasicHeader } from '../../actions/BasicHeader';
import { ModalBottomButtonContainer } from './Styles';
import { SecondaryButton, SuccessButton } from '../connectedForm/Button';
import FluentModal from './FluentModal';

const RecalculatePricingModal = ({
  onClose,
  onChange,
  isOpen,
  quoteToOrder,
}: {
  isOpen: boolean;
  onClose: () => void;
  onChange: (newValue: boolean) => void;
  quoteToOrder: boolean;
}) => {
  const recalculate = () => {
    //We've set this modal to a dataid of 'salesOrder.recalculatePricing' so we can just pass 'true' which should trigger a temporary save
    //with that flag set, and then the services can handle the recalculation.
    onChange(true);
    onClose();
  };

  let message;
  if (quoteToOrder) {
    message = 'Converting Quote to Order - Should Pricing be Recalculated?';
  } else {
    message = 'Order from Template/Duplicate Order - Should Pricing be Recalculated?';
  }

  return (
    <FluentModal isOpen={isOpen} styles={{ main: { width: '600px', paddingBottom: '60px' } }}>
      <BasicHeader>Recalculate Pricing</BasicHeader>
      <div style={{ padding: '1em' }}>
        <p>{message}</p>
      </div>
      <ModalBottomButtonContainer>
        <SecondaryButton
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
        >
          Skip
        </SecondaryButton>
        <SuccessButton
          onClick={(e) => {
            e.preventDefault();
            recalculate();
          }}
        >
          Recalculate
        </SuccessButton>
      </ModalBottomButtonContainer>
    </FluentModal>
  );
};

export default RecalculatePricingModal;
